import { take, all, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { hideSplashScreen } from 'services/splash'
import { history } from 'routes'
import { loadAditionSDK, configureAdition } from 'services/adition'
import {
  SESSION_START,
  SESSION_START_ANONYMOUS,
  SESSION_SET_ERROR,
  SESSION_SET_FACEBOOK_TOKEN,
  StartAction,
  StartAnonymousAction,
} from 'store/modules/session'
import { SessionState } from '.'
import { AppState } from 'store/types'
import { areAdsDisabled } from 'store/modules/session/selectors'

function redirectAfterLoginSaga({ payload: { login, usingLogin } }: StartAction) {
  if (login.newUser) {
    history.push('/welcome')
  } else if (usingLogin) {
    history.push('/games')
  }
}

function redirectAfterLogoutSaga({ payload: usingLogout }: StartAnonymousAction) {
  if (usingLogout) {
    history.push('/')
  }
}

function* hideSplashScreenAfterSessionInitialized() {
  yield all([
    take([SESSION_START, SESSION_START_ANONYMOUS, SESSION_SET_ERROR]),
    take(SESSION_SET_FACEBOOK_TOKEN),
  ])

  hideSplashScreen()
}

function* initializeAds() {
  const sessionState: SessionState = yield select(
    (state: AppState) => state.session
  )

  if (!areAdsDisabled(sessionState)) {
    loadAditionSDK()
    configureAdition()
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(SESSION_START, redirectAfterLoginSaga),
    takeEvery(SESSION_START_ANONYMOUS, redirectAfterLogoutSaga),
    takeLatest(SESSION_START, initializeAds)
  ])

  yield hideSplashScreenAfterSessionInitialized()
}
